import { render } from "./CollectionDetailedSearchOldMaterials.vue?vue&type=template&id=680e4e15&scoped=true&ts=true"
import script from "./CollectionDetailedSearchOldMaterials.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchOldMaterials.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchOldMaterials.vue?vue&type=style&index=0&id=680e4e15&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680e4e15"]])

export default __exports__